export default "__VITE_ASSET__CCfdVUeZ__"